import request from '@/utils/request'
// 审批列表
export function spWorkWechatSpCorpOaConfigIndex(id) {
  return request({
    url: `/spWorkWechat/spCorp/oaConfigIndex?corp_primary_id=${id}`,
    method: 'get'
  })
}
// 添加
export function spWorkWechatSpCorpOaConfigAdd(data) {
  return request({
    url: '/spWorkWechat/spCorp/oaConfigAdd',
    method: 'post',
    data
  })
}
// 修改
export function spWorkWechatSpCorpOaConfigUpdate(data) {
  return request({
    url: '/spWorkWechat/spCorp/oaConfigUpdate',
    method: 'post',
    data
  })
}
// 删除
export function spWorkWechatSpCorpOaConfigDel(data) {
  return request({
    url: '/spWorkWechat/spCorp/oaConfigDel',
    method: 'post',
    data
  })
}
// 配置状态修改
export function spWorkWechatSpCorpOaConfigSetStatus(data) {
  return request({
    url: '/spWorkWechat/spCorp/oaConfigSetStatus',
    method: 'post',
    data
  })
}

// 汇报列表
export function spWorkWechatSpCorpReportConfigIndex(id) {
  return request({
    url: `/spWorkWechat/spCorp/reportConfigIndex?corp_primary_id=${id}`,
    method: 'get'
  })
}
// 添加
export function spWorkWechatSpCorpReportConfigAdd(data) {
  return request({
    url: '/spWorkWechat/spCorp/reportConfigAdd',
    method: 'post',
    data
  })
}
// 修改
export function spWorkWechatSpCorpReportConfigUpdate(data) {
  return request({
    url: '/spWorkWechat/spCorp/reportConfigUpdate',
    method: 'post',
    data
  })
}
// 删除
export function spWorkWechatSpCorpReportConfigDel(data) {
  return request({
    url: '/spWorkWechat/spCorp/reportConfigDel',
    method: 'post',
    data
  })
}
// 配置状态修改
export function spWorkWechatSpCorpOaReportConfigSetStatus(data) {
  return request({
    url: '/spWorkWechat/spCorp/reportConfigSetStatus',
    method: 'post',
    data
  })
}
// 获取小程序访问次数
export function officialAccountpageDataStatistics(data) {
  return request({
    url: '/officialAccount/pageDataStatistics',
    method: 'post',
    data
  })
}
export function officialAccountpageDataStatisticslist(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/click_record',
    method: 'get',
    params
  })
}
// 获取小程序访问次数
export function kiadwertwqw(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/default_a',
    method: 'post',
    data
  })
}
// 修改链接
export function batchupdatedelayedmsgurl(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/batch_update_delayed_msg_url',
    method: 'post',
    data
  })
}
